/** Standard Pixi v8 filter vertex shader (GLSL ES 3.00; Pixi prepends the version). */
export const FILTER_VERTEX_GLSL = `
in vec2 aPosition;
out vec2 vTextureCoord;

uniform highp vec4 uInputSize;
uniform highp vec4 uOutputFrame;
uniform highp vec4 uOutputTexture;

vec4 filterVertexPosition(void) {
  vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
  position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
  position.y = position.y * (2.0 * uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;
  return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord(void) {
  return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

void main(void) {
  gl_Position = filterVertexPosition();
  vTextureCoord = filterTextureCoord();
}
`;

/**
 * Fragment-side helper: local 0..1 UV across the filtered object's frame.
 * `vTextureCoord` spans the object's frame inside the (larger) input texture;
 * dividing by that span yields the same frame-local coordinate the original
 * `uvRect` produced for atlas sprites — per object, no atlas rect needed.
 */
export const FRAME_LOCAL_UV_GLSL = `
vec2 frameLocalUv(vec2 textureCoord) {
  return textureCoord * uInputSize.xy / uOutputFrame.zw;
}
`;
